import React from 'react';
import Cookie from 'js-cookie';
import {Route, Redirect} from 'react-router-dom';

const PrivateRoute = ({...props}) => {
    return Cookie.get(process.env.REACT_APP_TOKEN) ? <Route {...props} /> : <Redirect to="/login" />;
};

export default PrivateRoute;
